import Button from '../../new_arch/components/Button/Button';
import CloseIcon from './Close.svg';

import './UnsupportedFileFormatsPopup.scss';

type UnsupportedFileFormatsPopupProps = {
	unsupportedFormats: string[],
	onCancel: () => void,
	onConfirm: () => void
}

const UnsupportedFileFormatsPopup = ( {
	unsupportedFormats, onCancel, onConfirm
}: UnsupportedFileFormatsPopupProps ) => {
	const message = 'Sorry, something unexpected happened, and not all files were successfully uploaded. Please try uploading the files again. If the issue persists, check your internet connection.';

	return (
		<div className="UnsupportedFileFormatsPopup">
			<div className="dialog">
				<button className="close-icon" onClick={onCancel} data-testid="close-icon">
					<img src={CloseIcon} alt="close" width={24} height={24} />
				</button>
				<h4>Incomplete Image Upload</h4>
				<div className="description-container">
					<p className="description">{message}</p>
					<div className="unsupported-formats-container">
						<p className="title">Unsupported file format:</p>
						<p className="unsupported-formats">
							{unsupportedFormats.join( ', ' )}
						</p>
					</div>
				</div>
				<Button
					type="filled"
					color="primary"
					onClick={onConfirm}
				>
					Got it
				</Button>
			</div>
		</div>
	);
};

export default UnsupportedFileFormatsPopup;
